import cn from 'classnames';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';
import {useHistory} from 'react-router-dom';

import createColFromItem from '@/utils/createColFromItem';

export const LinkTo = ({to, ...props}) => {
  const {push} = useHistory();
  return <div onClick={() => push(to)} {...props}/>;
};

LinkTo.propTypes = {
  children: PropTypes.any,
  to: PropTypes.any
};

export const createRenderLinkRow = ({
  path,
  info,
  subKeysToShow,
  key = '_id',
  extra = () => null,
  keyUse = true
}) => {
  const getValueToShow = (obj) => {
    switch (typeof info) {
      case 'function':
        return info(obj);
      case 'string':
        return get(obj, info);
      default:
        return null;
    }
  };
  
  const getPathToUse = (obj) => {
    switch (typeof path) {
      case 'function':
        return path(obj);
      case 'string':
        return path;
      default:
        return null;
    }
  };
  
  const getKeyToUse = (obj) => {
    switch (typeof key) {
      case 'function':
        return key(obj);
      case 'string':
        return key;
      default:
        return null;
    }
  };
  
  const getUseValue = (obj) => {
    switch (typeof keyUse) {
      case 'function':
        return keyUse(obj);
      default:
        return keyUse;
    }
  };
  
  const getValueFromItemToShow = createColFromItem(subKeysToShow);
  
  // eslint-disable-next-line react/display-name
  return (text, item) => {
    
    const content = <div className="px-2">
      <div className={cn('font-bold lg:font-normal text-lg lg:text-base cursor-pointer', {'text-primary': !!path})}>
        {getValueToShow(item) || text}
      </div>
      {getValueFromItemToShow({item})}
      {extra && extra(text, item)}
    </div>;
    
    return getPathToUse(item)
      ? (
        <LinkTo to={`${getPathToUse(item)}${getUseValue(item) ? `/${item[getKeyToUse(item)]}` : ''}`}>
          {content}
        </LinkTo>
      )
      : content;
  };
};
